import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OTPField = styled.input`
  font-size: 24px;
  padding: 8px;
  text-align: center;
  border: none;
  border-bottom: 1.5px solid #a1a2a4;
  width: 40px;
  margin: 0 5px;

  &:focus {
    outline: none;
  }
  @media (max-width: 767px) {
    width: 20px;
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const OTPInput = ({ onOTPChange }) => {
  const [otp, setOTP] = React.useState(Array(6).fill(''));
  const otpInputs = Array.from({ length: 6 });

  const handleChange = (e, index) => {
    let { value } = e.target;
    value = value.replace(/\D/g, '');
    value = value.slice(0, 1);
    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);

    if (value !== '' && index < otpInputs.length - 1) {
      otpInputs[index + 1].focus();
    }
    const otpValue = newOTP.join('');
    onOTPChange(otpValue);
  };
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      otpInputs[index - 1].focus();
    }
    if (['ArrowUp', 'ArrowDown', '-', '.', 'e', 'E'].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Container>
      {otpInputs.map((_, index) => (
        <OTPField
          key={index}
          type="number"
          value={otp[index]}
          maxLength={1}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onWheel={(e) => e.target.blur()}
          ref={(input) => (otpInputs[index] = input)}
        />
      ))}
    </Container>
  );
};

OTPInput.propTypes = {
  onOTPChange: PropTypes.func,
};
export default OTPInput;
